import { css, unsafeCSS } from 'lit';
import { fsFontWeightSemibold } from '@cof/fs-tokens';

import { fsDesignToken } from '../core/style-util.js';

export const style = css`
  .main {
    display: block;
    margin: ${fsDesignToken('fsSizeSpacingLarge2')} auto;
  }

  .iconic-main {
    display: block;
    margin: 0 auto ${fsDesignToken('fsSizeSpacingLarge2')} auto;
  }

  .page-content {
    margin: auto;
    max-width: 34rem;
    padding: 0 ${fsDesignToken('fsSizeSpacingMedium2')};
  }

  .consent-modal-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .fs-body-text {
    margin-bottom: 0.5em;
  }

  .consent-modal-body-text {
    margin-bottom: 0;
  }

  .consent-modal-section fs-body-text:last-of-type {
    margin-bottom: 0;
  }

  .bold-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
  }

  .consent-modal__list {
    margin-bottom: 0;
    margin-top: 0;
    padding-left: 1.5em;
  }

  .list_element {
    padding-top: 0.5em;
  }
`;
